/**
 * Иконка Font Awesome Pro (Regular) — одна на всё приложение.
 *
 * Разметка встроена при сборке (`tools/build-icon-pack.mjs`), цвет — от
 * текста. Старые имена тоже понимаются: до перехода на Font Awesome
 * категории хранили имена lucide, а ещё раньше — эмодзи, счета — эмодзи.
 * Так рисуется и то, что пришло со старого устройства.
 */
import { ICON_SVG, ICON_SVG_SOLID, LEGACY_ICON } from './icon-pack.js';

/** Имя Font Awesome для сохранённого значка; `undefined` — такого нет. */
export function iconName(name: string | undefined | null): string | undefined {
  if (!name) return undefined;
  if (ICON_SVG[name]) return name;
  const trimmed = name.trim();
  return LEGACY_ICON[trimmed] ?? LEGACY_ICON[trimmed.replace(/️/g, '')];
}

/** Есть ли у значка рисунок — или это чужой символ, который рисуется текстом. */
export const hasIcon = (name: string | undefined | null): boolean => iconName(name) !== undefined;

export function Icon({ name, size = 20, className, solid }: {
  name: string;
  /** Высота в пикселях; ширина — по пропорции иконки. */
  size?: number;
  className?: string;
  /** Сплошной стиль — есть только у иконок нижнего меню. */
  solid?: boolean;
}) {
  const resolved = solid && ICON_SVG_SOLID[name] ? name : iconName(name);
  const entry = resolved ? (solid ? ICON_SVG_SOLID[resolved] : undefined) ?? ICON_SVG[resolved] : undefined;
  if (!entry) return null;
  const [width, body] = entry;
  return (
    <svg className={`fa${className ? ` ${className}` : ''}`} data-icon={resolved} viewBox={`0 0 ${width} 512`}
      height={size} width={Math.round((size * width) / 512)} fill="currentColor" aria-hidden="true"
      focusable="false" dangerouslySetInnerHTML={{ __html: body }} />
  );
}
